import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";

export function Navbar({ light = false }) {
  return (
    <header className="relative z-20 w-full">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 sm:px-8">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-home-link">
          <img
            src={BRAND.logo}
            alt="Drawn Into Legend"
            className="h-11 w-11 rounded-full object-cover ring-2 ring-[#F4D03F]/60 transition-transform group-hover:scale-105"
          />
          <span className="font-display text-lg font-extrabold leading-tight text-[#4A235A] sm:text-xl">
            Drawn Into <span className="text-[#9B5DE5]">Legend</span>
          </span>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-4">
          <Link
            to="/order"
            data-testid="nav-order-lookup"
            className="rounded-full px-3 py-2 text-sm font-bold text-[#5C4A61] transition-colors hover:text-[#4A235A]"
          >
            Find my order
          </Link>
          <Link
            to="/create"
            data-testid="nav-start-create"
            className="rounded-full bg-[#4A235A] px-5 py-2.5 text-sm font-bold text-white transition-transform hover:-translate-y-0.5"
          >
            Start creating
          </Link>
        </nav>
      </div>
    </header>
  );
}
